import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot, Router } from '@angular/router';

import { AnnouncementService } from './announcement.service';
import { Announcement } from '../models';
import { AlertService } from '@app/core/services';


@Injectable({
	providedIn: 'root'
})
export class AnnouncementResolverService implements Resolve<Announcement[]> {

	constructor(
		private announcementService: AnnouncementService
	) { }

	resolve(route: ActivatedRouteSnapshot): Observable<Announcement[]> {
		return this.announcementService.getAnnouncements();
	}
}